import Cookies from "js-cookie";

const authCookieOptions = {
  path: "/",
  secure:
    typeof window !== "undefined" && window.location.protocol === "https:",
  sameSite: "Strict" as const,
};

export const logout = () => {
  // Match attrs used when the cookie was set (login vs refresh interceptor).
  Cookies.remove("accessToken", authCookieOptions);
  Cookies.remove("refreshToken", authCookieOptions);
  Cookies.remove("accessToken");
  Cookies.remove("refreshToken");
  Cookies.remove("from");
  localStorage.removeItem("authToken");
  localStorage.removeItem("sessionToken");
  window.location.replace("/login");
};
